"use client";
import FaqAccordion from "@/components/organisms/Faq/FaqList/FAQ";
import { MappedFaqItem } from "@/services/faq/types";
import { useTranslations } from "next-intl";
import React, { useEffect } from "react";

export default function FaqList({ faqData }: any) {
  const t = useTranslations('faq');
  const categoriesWithFaqs: { [category: string]: MappedFaqItem[] } = {};
  const allCategories = new Set<string>();
  faqData.items.forEach((faq: MappedFaqItem) => {
    const categories = Array.isArray(faq.category)
      ? faq.category
      : [faq.category];

    categories.forEach((category) => {
      allCategories.add(category);

      if (!categoriesWithFaqs[category]) {
        categoriesWithFaqs[category] = [];
      }

      categoriesWithFaqs[category].push(faq);
    });
  });

  const categories = Array.from(allCategories).sort();

  useEffect(() => {
    const handleAnchorClick = (e: Event) => {
      const target = e.target as HTMLElement;
      
      if (target.tagName === 'A' && target.getAttribute('href')?.startsWith('#')) {
        e.preventDefault();
        
        const targetId = target.getAttribute('href')?.substring(1);
        const targetElement = document.getElementById(targetId || '');
        
        if (targetElement) {
          const offsetTop = targetElement.getBoundingClientRect().top + window.scrollY - 200;
          
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        }
      }
    };

    const navLinks = document.querySelectorAll('nav a[href^="#"]');
    navLinks.forEach(link => {
      link.addEventListener('click', handleAnchorClick);
    });

    return () => {
      navLinks.forEach(link => {
        link.removeEventListener('click', handleAnchorClick);
      });
    };
  }, [categories]);

  useEffect(() => {
    if (window.location.hash) {
      setTimeout(() => {
        const targetId = window.location.hash.substring(1);
        const targetElement = document.getElementById(targetId);
        
        if (targetElement) {
          const offsetTop = targetElement.getBoundingClientRect().top + window.scrollY - 100;
          
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        }
      }, 300);
    }
  }, []);

  return (
    <div className="xl:container xl:mx-auto">
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex pt-0  gap-32 xl:gap-104 md:gap-64 xl:pt-32 flex-col xl:flex-row">
          
          <div className="xs:bg-primary-100 xl:bg-white xs:py-32 xl:py-0 xl:w-1/4 mb-8 xl:mb-0 xl:pr-8">
            <div className="xl:sticky xl:top-[180px] w-full container mx-auto ">
              <div className="bg-primary-100 xl:bg-white py-8 xl:py-0 px-4 xl:px-0">
                <h2 className="text-l-bold text-neutral-900 mb-16">
                  {t("thisPage")}
                </h2>
                <nav className="flex flex-col space-y-2" aria-label="Categorias de perguntas frequentes">
                  {categories.map((category) => (
                    <a
                      key={category}
                      href={`#${category.toLowerCase().replace(/\s+/g, "-")}`}
                      className="py-8 text-m-regular text-neutral-900 hover:text-primary-600"
                    >
                      {category}
                    </a>
                  ))}
                </nav>
              </div>
            </div>
          </div>

          <div className="w-full xs:mt-32 md:mt-0 container mx-auto xl:w-3/4">
            <div className="space-y-12">
              {categories.map((category) => (
                <section
                  key={category}
                  id={category.toLowerCase().replace(/\s+/g, "-")}
                  className="scroll-mt-24 mb-64 pt-24"
                >
                  <h2 className="text-l-bold text-primary-600 mb-6">{category}</h2>
                  <FaqAccordion
                    faqs={categoriesWithFaqs[category] || []}
                    category={category}
                  />
                </section>
              ))}
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
}
